import { Box } from "@mui/material";
import React, { FunctionComponent, memo } from "react";

import { MEASURE_UNIT_DISPLAY_MAP } from "components";
import { EMPTY_CELL_VALUE } from "consts";

import { MaybeNull } from "types";

import { isNullOrUndefined, toUSNumber } from "utils";

import { EmissionCellTooltip } from "./emission-cell-tooltip";

export const EmissionCell: FunctionComponent<{
  value?: MaybeNull<string>;
  explanation?: MaybeNull<string>;
  unit?: MaybeNull<string>;
  unitValueShow?: MaybeNull<boolean>
}> = memo(({ value, explanation, unit, unitValueShow }) => (
  <>
    {!isNullOrUndefined(value) ? (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {unitValueShow ?
          <div>{toUSNumber(value!)} {unit}</div>
          :
          <div>
            {toUSNumber(value!)} t {MEASURE_UNIT_DISPLAY_MAP.co2}
          </div>}
        <Box sx={{ mt: -1 }} >
          <EmissionCellTooltip explanation={explanation} />
        </Box>
      </Box>
    ) : (
      EMPTY_CELL_VALUE
    )}
  </>
));
